import { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { httpsCallable } from "firebase/functions";
import { database, functions } from "../constants/firebase";
export function useRecord(path) {
  const [state, setState] = useState({
    data: null,
    loading: Boolean(path),
    error: "",
  });
  useEffect(() => {
    setState({ data: null, loading: Boolean(path), error: "" });
    if (!path) return;
    return onValue(
      ref(database, path),
      (s) => setState({ data: s.val(), loading: false, error: "" }),
      (e) => setState({ data: null, loading: false, error: e.message }),
    );
  }, [path]);
  return state;
}
export const rows = (data) =>
  Object.entries(data || {})
    .filter(([, v]) => v && typeof v === "object")
    .map(([id, v]) => ({ ...v, id }));
export const call = async (name, data = {}) =>
  (await httpsCallable(functions, name)(data)).data;
export const userVisible = (u) =>
  !["pending", "rejected", "suspended"].includes(u?.status);
export const jobVisible = (j, u) =>
  j?.status === "active" &&
  !["pending", "rejected"].includes(j.approvalStatus) &&
  Boolean(j.title && j.role && j.payRate && j.location && j.hostId) &&
  j.hostId !== u?.uid &&
  (u?.isTester === true ||
    !`${j.title || ""} ${j.description || ""}`
      .toLowerCase()
      .includes("mangofire")) &&
  (j.env !== "test" || Boolean(u?.isTester));
export const dateValue = (v) =>
  typeof v === "number" ? v : Date.parse(v) || 0;
export const paid = (r) =>
  r.payoutStatus === "paid" ||
  r.status === "paid" ||
  r.reviewsCompleted === true;
export const money = (amount, currency = "ZAR") =>
  new Intl.NumberFormat(currency.toUpperCase() === "ZAR" ? "en-ZA" : undefined, { style: "currency", currency }).format(
    Number(amount) || 0,
  );
export const safeUrl = (value) => {
  try {
    const u = new URL(value);
    return ["https:", "http:"].includes(u.protocol) ? u.href : "";
  } catch {
    return "";
  }
};
export const NICHES = [
  "Filmmaker",
  "Content Creator",
  "Editor",
  "Gaffer",
  "Drone Operator",
  "VFX Artists",
  "Colorist",
  "Sound Designer",
  "Business",
  "Producer",
  "Director",
  "Grip",
  "Production Designer",
  "Makeup Artist",
  "Actor",
  "Actress",
  "Continuity",
  "Script writing",
  "Lighting",
  "Trainee",
  "Photographer",
];

export const isProUser = user => {
 if (!user || user.subscriptionStatus === 'expired') return false;
 if (user.subscriptionStatus === 'trial' && Number(user.trialEndDate) > 0 && Number(user.trialEndDate) <= Date.now()) return false;
 return ['Host','Pro'].includes(user.role) || user.isHost === true || ['lifetime','active'].includes(user.subscriptionStatus);
};
